import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { WalletIcon, SaveIcon, CheckCircleIcon } from 'lucide-react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { MOCK_WALLET_SETTINGS } from '../../lib/mockData';
import { formatVND } from '../../lib/formatters';
export function WalletRulesPage() {
  const [settings, setSettings] = useState({
    ...MOCK_WALLET_SETTINGS
  });
  const [saved, setSaved] = useState(false);
  const handleSave = () => {
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };
  const update = (key: string, value: number | boolean) => {
    setSettings(prev => ({
      ...prev,
      [key]: value
    }));
  };
  return <div data-id="element-1060">
      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} data-id="element-1061">
        <h1 className="text-2xl font-bold text-white mb-1 flex items-center gap-3" data-id="element-1062">
          <WalletIcon className="w-7 h-7 text-[#C8A84E]" data-id="element-1063" />
          Cài Đặt Ví Điện Tử
        </h1>
        <p className="text-sm text-[#666666] mb-6" data-id="element-1064">
          Quản lý quy tắc nạp tiền, thưởng, và hết hạn
        </p>
      </motion.div>

      {saved && <motion.div initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} className="mb-4 bg-[#22C55E]/10 border border-[#22C55E]/20 rounded-xl p-3 flex items-center gap-2" data-id="element-1065">
          <CheckCircleIcon className="w-4 h-4 text-[#22C55E]" data-id="element-1066" />
          <span className="text-sm text-[#22C55E]" data-id="element-1067">Đã lưu cài đặt!</span>
        </motion.div>}

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-1068">
        <Card title="Quy Tắc Nạp Tiền" data-id="element-1069">
          <div className="space-y-4" data-id="element-1070">
            <Input label="Tỷ lệ thưởng nạp tiền (%)" type="number" value={settings.bonusPercent.toString()} onChange={e => update('bonusPercent', parseFloat(e.target.value) || 0)} hint={`Ví dụ: Nạp 10M → Thưởng ${formatVND(10000000 * settings.bonusPercent / 100)}`} data-id="element-1071" />
            <Input label="Bội số nạp tiền (VNĐ)" type="number" value={settings.depositIncrement.toString()} onChange={e => update('depositIncrement', parseInt(e.target.value) || 0)} hint={`Khách chỉ được nạp theo bội số ${formatVND(settings.depositIncrement)}`} data-id="element-1072" />
            <Input label="Nạp tối thiểu (VNĐ)" type="number" value={settings.minimumDeposit.toString()} onChange={e => update('minimumDeposit', parseInt(e.target.value) || 0)} data-id="element-1073" />
          </div>
        </Card>

        <Card title="Quy Tắc Hết Hạn & Hoàn Tiền" data-id="element-1074">
          <div className="space-y-4" data-id="element-1075">
            <Input label="Thời hạn tín dụng (tháng)" type="number" value={settings.expirationMonths.toString()} onChange={e => update('expirationMonths', parseInt(e.target.value) || 0)} hint="Tín dụng hết hạn sau số tháng này kể từ giao dịch cuối" data-id="element-1076" />
            <div data-id="element-1077">
              <label className="block text-sm font-medium text-[#B0B0B0] mb-1.5" data-id="element-1078">
                Cho phép hoàn tiền
              </label>
              <button onClick={() => update('allowRefunds', !settings.allowRefunds)} className={`flex items-center gap-3 w-full p-3 rounded-lg border transition-colors ${settings.allowRefunds ? 'border-[#C8A84E] bg-[#C8A84E]/10' : 'border-[#2A2A2A]'}`} data-id="element-1079">
                <div className={`w-10 h-6 rounded-full transition-colors ${settings.allowRefunds ? 'bg-[#C8A84E]' : 'bg-[#2A2A2A]'}`} data-id="element-1080">
                  <div className={`w-5 h-5 bg-white rounded-full mt-0.5 transition-transform ${settings.allowRefunds ? 'ml-[18px]' : 'ml-0.5'}`} data-id="element-1081" />
                </div>
                <span className="text-sm text-white" data-id="element-1082">
                  {settings.allowRefunds ? 'Có' : 'Không'}
                </span>
              </button>
            </div>
            {settings.allowRefunds && <Input label="Thời hạn hoàn tiền (ngày)" type="number" value={settings.maxRefundDays.toString()} onChange={e => update('maxRefundDays', parseInt(e.target.value) || 0)} data-id="element-1083" />}
          </div>
        </Card>
      </div>

      <div className="mt-6 flex justify-end" data-id="element-1084">
        <Button onClick={handleSave} data-id="element-1085">
          <SaveIcon className="w-4 h-4" data-id="element-1086" />
          Lưu Cài Đặt
        </Button>
      </div>
    </div>;
}